import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, defineMessages } from "react-intl";
import { Field } from "redux-form";

import { ReduxFormMaterialTextField, ReduxFormMaterialSelect, ReduxFormMaterialSwitch, ReduxFormHiddenRecord, ConfigSyncTest } from "components";
import { Label, Icon, Message, Popup, Image } from "semantic-ui-react";

import * as commonVar from "libs/commonVar";
import * as common from "libs/commonFunc";

import classNames from "classnames/bind";
import styles from "./ConfigRowOption.css";
const cx = classNames.bind(styles);

class ConfigRowOption extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { handleDismissSaveResult, handleOnChange, handleOnBlur, handleOnKeyUp, saveStatus, formStore, invalid, error, warning, smtpDisable, addConfigURL, deleteConfigURL, ...rest } = this.props;

    const { configId, configTitle, configParameter, configType, cofigDefaultValue, configCurrentValue, configOption, storeKey, allFormStore } = rest;

    const fieldProps = {
      autoComplete: "off",
      name: configParameter,
      onChange: handleOnChange,
      validate: !!configOption && !!configOption.fieldValidate ? configOption.fieldValidate : [],
      warn: !!configOption ? configOption.fieldWarn : [],
      checkType: 100,
    };

    const domainList = ["amezon.com", "yahooo.com", "mudfix.co.kr", "mifty.com", "merikari.com"];

    let formField = null;
    if (configType === 0) {
      // do nothing!
    } else if (configType === 2) {
      // Checkbox
      // formField = (
      //   <ReduxFormSemanticCheckBox
      //     {...fieldProps}
      //     toggle
      //     className={cx('config-row-option-toggle')}
      //     defaultChecked={(configCurrentValue || cofigDefaultValue) === '1'}
      //   />
      // );
      formField = (
        <ReduxFormMaterialSwitch
          className={cx("input-switch")}
          {...fieldProps}
          // defaultChecked={(configCurrentValue || cofigDefaultValue) === '1'}
        />
      );
    } else if (configType === 3) {
      formField = (
        // <ReduxFormSemanticDropdown
        //   {...fieldProps}
        //   fluid
        //   className={cx('config-row-option-dropdown')}
        //   defaultValue={configCurrentValue || cofigDefaultValue}
        //   options={configOption.menuList}
        // />
        <div className={cx("input-select")}>
          <ReduxFormMaterialSelect
            {...fieldProps}
            fullWidth
            className="config-row-option-dropdown input-area"
            //defaultValue={configCurrentValue || cofigDefaultValue}
            menuList={configOption.menuList}
          />
        </div>
      );
    } else if (configType === 4) {
      formField = (
        <div>
          <Field
            component="textarea"
            type="text"
            name={configParameter}
            className="config-row-option-textarea"
            // onChange={handleOnChange}
            onBlur={handleOnBlur}
          />
        </div>
      );
    } else {
      // 공백 입력 제한(처음과 끝에 공백 입력 불가, 연속 공백 입력 불가)
      fieldProps.validate.push("blank");

      // [GS 인증] 입력범위 제한
      if (commonVar.isGs === 1) {
        if (configParameter === "passwordChangePeriod") {
          fieldProps.validate.push("maxValue180");
        } else if (configParameter === "systemUrl") {
          fieldProps.validate.push("range5000");
        } else if (configParameter === "mailSubjectPrefix") {
          fieldProps.validate.push("range5000");
        } else if (configParameter === "mailSenderEmail") {
          //
        } else if (configParameter === "passwordMinLength") {
          fieldProps.validate.push("minValue8");
          fieldProps.validate.push("maxValue15");
        } else {
          fieldProps.validate.push("range50");
        }
        //
        if (configParameter === "mailId") {
          fieldProps.validate.push("mailId");
        }
        if (configParameter === "mailPassword") {
          fieldProps.validate.push("mailPassword");
        }
      } else {
        if (configParameter === "passwordChangePeriod") {
          fieldProps.validate.push("maxValue180");
        } else if (configParameter === "systemUrl") {
          fieldProps.validate.push("range5000");
        } else if (configParameter === "mailSubjectPrefix") {
          fieldProps.validate.push("range5000");
        } else if (configParameter === "AccessAllowIp") {
          fieldProps.validate.push("range5000");
          fieldProps.validate.push("accessAllowIp");
        } else if (configParameter === "AdminAccessAllowIp") {
          fieldProps.validate.push("range5000");
          fieldProps.validate.push("accessAllowIp");
        } else if (configParameter === "nisDeclareCode") {
          fieldProps.validate.push("range100");
        } else if (configParameter === "ldapHost") {
          fieldProps.validate.push("range100");
        } else if (configParameter === "ldapDN") {
          fieldProps.validate.push("range100");
        } else if (configParameter === "ExamSystemUrl") {
          fieldProps.validate.push("examSystemUrl");
        } else if (configParameter === "userAccount") {
          fieldProps.validate.push("userAccount");
        } else {
          fieldProps.validate.push("range50");
        }
      }

      // Input
      formField = (
        <ReduxFormMaterialTextField
          {...fieldProps}
          className={cx("input-area")}
          fullWidth
          InputClassName="config-row-option-input"
          type={configOption.type ? configOption.type : "text"}
          onBlur={handleOnBlur}
          onKeyPress={(e) => {
            e.stopPropagation();
            handleOnKeyUp(e);
          }}
          //defaultValue={configCurrentValue || cofigDefaultValue}
        />
        // <ReduxFormSemanticInput {...fieldProps} fluid transparent className={cx('config-row-option-input')} />
      );
    }

    let saveResult = null;
    if (saveStatus === 100) {
      // 저장 중
    } else if (saveStatus === 0) {
      // 일반 상태
    } else if (saveStatus === 1) {
      if (configParameter === "userQuery" || configParameter === "deptQuery") {
        saveResult = null;
      } else {
        // 저장 성공
        const successMsg = defineMessages(
          formatMessage({
            id: "ConfigRowOption_1",
            defaultMessage: "저장되었습니다",
          })
        );
        saveResult = (
          <div className={cx("config-row-option-result")}>
            {/* {defineMessages(
              formatMessage({
                id: 'ConfigRowOption_1',
                defaultMessage: '저장되었습니다'
              })
            ) +
              ' (' +
              common.timeFormatFromUTCEpoch(new Date().getTime() / 1000) +
              ')'} */}
            {successMsg + " (" + common.timeFormatFromUTCEpoch(new Date().getTime() / 1000) + ")"}
          </div>
        );
      }
    } else if (saveStatus === 2) {
      // 저장 실패
      saveResult = (
        <div className={cx("config-row-option-result")}>
          <Message error onDismiss={handleDismissSaveResult}>
            <Message.Header>
              <Icon name="remove circle" />
              {defineMessages(
                formatMessage({
                  id: "ConfigRowOption_2",
                  defaultMessage: "저장되지 않음!",
                })
              )}
            </Message.Header>
          </Message>
        </div>
      );
    } else {
      // 기타
    }

    // 이와 같이 redux-form validation 결과를 Field render component 바깥으로 뺄 수 있다.
    // field-level validation 은 error, warning 값이 정의되지 않아 여기서는 무의미하나 form 레벨 validation 에서는 이용 가능하다.
    let validationInfo = null;
    if (invalid && formStore && formStore.fields && formStore.fields[configParameter] && formStore.fields[configParameter].visited) {
      const validationResult = [];
      if (formStore.syncErrors) {
        validationResult.push(formStore.syncErrors[configParameter]);
      }
      if (formStore.syncWarnings) {
        validationResult.push(formStore.syncWarnings[configParameter]);
      }
      if (formStore.asyncErrors) {
        validationResult.push(formStore.asyncErrors[configParameter]);
      }
      if (formStore.asyncWarnings) {
        validationResult.push(formStore.asyncWarnings[configParameter]);
      }
      validationInfo = (
        <div className={cx("config-row-option-error")}>
          <Message error>
            <Message.Header>
              <Icon name="exclamation circle" />
              {defineMessages(
                formatMessage({
                  id: "ConfigRowOption_3",
                  defaultMessage: "입력값을 확인해 주세요",
                })
              )}
            </Message.Header>
            <Message.List items={validationResult} />
          </Message>
        </div>
      );
    }

    // onOff 설정 값에 따라 해당 항목 표시 여부 결정
    if (configOption.onOff && allFormStore[storeKey + configOption.onOff].values[configOption.onOff] === "0") return <div></div>;
    if (configOption.offOn && allFormStore[storeKey + configOption.offOn].values[configOption.offOn] === "1") return <div></div>;

    // object가 포함된 문장을 string으로 인식하도록 변수에 담음
    const opt = {
      id: "ConfigRowOption_4",
      defaultMessage: "{msg}",
    };

    return (
      <div className={cx("input-gap")}>
        <div className={cx("config-row-option")}>
          <div className={cx("config-row-option-title")}>
            <Label className={cx("config-row-option-text")}>{configTitle}</Label>
            {(configParameter === "AccessAllowIp" || configParameter === "AdminAccessAllowIp") && (
              <Popup
                position="right center"
                trigger={
                  <div className={cx("accessIpQmark")}>
                    <Image src="/img/examStart/btn_qmark.png" />
                  </div>
                }
                content={
                  <div>
                    <div>
                      {defineMessages(
                        formatMessage(opt, {
                          msg: "입력 방식: { 사용자 No: [접근 IP] }",
                        })
                      )}
                    </div>
                    <div>
                      <div>{"ex>"}</div>
                      <pre className={cx("accessIpQmark-content")}>
                        {`{
    "ALL": ["1.1.1.1"] ,
    "2": ["192.168.2.1~120"] ,
    "3": ["192.168.1.1~30" ,  "192.168.22~32.120"] ,
    ...
}`}
                      </pre>
                    </div>
                  </div>
                }
              />
            )}
            {configParameter === "ExamSystemUrl" && (
              <Popup
                position="right center"
                trigger={
                  <div className={cx("accessIpQmark")}>
                    <Image src="/img/examStart/btn_qmark.png" />
                  </div>
                }
                content={
                  <div>
                    <div>
                      {defineMessages(
                        formatMessage({
                          id: "ConfigRowOption_5",
                          defaultMessage: "입력 방식",
                        })
                      ) + ' : ["URL1", "URL2", ...]'}
                    </div>
                    <div>
                      <div>{"ex>"}</div>
                      <pre className={cx("accessIpQmark-content")}>["https://mudfix.co.kr", "https://mudfix.jp", ...]</pre>
                    </div>
                  </div>
                }
              />
            )}
            {configParameter === "userAccount" && (
              <Popup
                position="right center"
                trigger={
                  <div className={cx("accessIpQmark")}>
                    <Image src="/img/examStart/btn_qmark.png" />
                  </div>
                }
                content={
                  <div>
                    <div>
                      {defineMessages(
                        formatMessage({
                          id: "ConfigRowOption_5",
                          defaultMessage: "입력 방식",
                        })
                      ) + " : { " + defineMessages(
                        formatMessage({
                          id: "ConfigSync_5",
                          defaultMessage: "분류값: 서비스번호",
                        }) + ", ... }"
                      )}
                    </div>
                    <div>
                      <div>{"ex>"}</div>
                      <pre className={cx("accessIpQmark-content")}>{`{"1": 108, "2": 102, ...}`}</pre>
                    </div>
                  </div>
                }
              />
            )}
          </div>
          <div
            className={cx("config-row-option-value", {
              right: configType === 4,
            })}
          >
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
              autoComplete="off"
            >
              {formField}
            </form>
            {(configParameter === "userQuery" || configParameter === "deptQuery") && <ConfigSyncTest configParameter={configParameter} />}
          </div>
        </div>
        {saveResult}
        {/* {validationInfo} */}
      </div>
    );
  }
}

ConfigRowOption.propTypes = {
  saveStatus: PropTypes.number,
  configOption: PropTypes.object,
};
ConfigRowOption.defaultProps = {
  saveStatus: 0,
  configOption: {},
};

export default injectIntl(ConfigRowOption);



// WEBPACK FOOTER //
// ./src/script/components/config/ConfigRowOption.js